import { createContext, useContext, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "id";
    return localStorage.getItem("xpdc-lang") || "id";
  });

  const setLanguage = (l) => {
    setLang(l);
    localStorage.setItem("xpdc-lang", l);
  };

  const toggleLanguage = () => setLanguage(lang === "id" ? "en" : "id");

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
